import { createSlice } from "@reduxjs/toolkit";

const subjectBasedTeachersSlice = createSlice({
  name: "subjectBasedTeachers",
  initialState: {
    subjectBasedTeachersList : [],
    loading: false,
    error: null,
  },
  reducers: {
    getSubjectBasedTeachersRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getSubjectBasedTeachersSuccess: (state, action) => {
      state.loading = false;
      state.subjectBasedTeachersList = action.payload;
    },
    getSubjectBasedTeachersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearSubjectBasedTeachers: (state) => {
      state.subjectBasedTeachersList = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  getSubjectBasedTeachersRequest,
  getSubjectBasedTeachersSuccess,
  getSubjectBasedTeachersFailure,
  clearSubjectBasedTeachers,
} = subjectBasedTeachersSlice.actions;

export default subjectBasedTeachersSlice.reducer;
